import { createContext, useReducer, useContext } from 'react'
import appReducer, { initialState } from './appReducer'

const AppContext = createContext(initialState)

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState)

  const appScreenerExecuted = strScreenerExecuted => {
    dispatch({
      type: 'APP_SCREENER_EXECUTED',
      payload: {
        screenerExecuted: strScreenerExecuted
      }
    })
  }
  const appPreloaderExecuted = bolPreloaderExecuted => {
    dispatch({
      type: 'APP_PRELOADER_EXECUTED',
      payload: {
        preloaderExecuted: bolPreloaderExecuted
      }
    })
  }
  const appNavigationExecuted = bolNavigationExecuted => {
    dispatch({
      type: 'APP_NAVIGATION_EXECUTED',
      payload: {
        navigationExecuted: bolNavigationExecuted
      }
    })
  }
  const appServiceId = txtServiceId => {
    dispatch({
      type: 'APP_SERVICE_ID',
      payload: {
        serviceId: txtServiceId
      }
    })
  }
  const appServiceSubject = txtServiceSubject => {
    dispatch({
      type: 'APP_SERVICE_SUBJECT',
      payload: {
        serviceSubject: txtServiceSubject
      }
    })
  }

  const value = {
    screenerExecuted: state.screenerExecuted,
    preloaderExecuted: state.preloaderExecuted,
    navigationExecuted: state.navigationExecuted,
    serviceId: state.serviceId,
    serviceSubject: state.serviceSubject,
    appScreenerExecuted,
    appPreloaderExecuted,
    appNavigationExecuted,
    appServiceId,
    appServiceSubject
  }
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

const useShop = () => {
  const context = useContext(AppContext)

  if (context === undefined) {
    throw new Error('useShop must be used within AppContext')
  }

  return context
}

export default useShop
